import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
} from '@angular/core';
import { DialogContent } from './dialog-content';
import { DialogFooter } from './dialog-footer';
import { DialogHeader } from './dialog-header';
import type {
    DialogCancelButtonInput,
    DialogConfirmButtonInput,
    ProcessingAppearance,
} from './models';

@Component({
    selector: 'qpx-dialog',
    imports: [DialogHeader, DialogContent, DialogFooter],
    templateUrl: './dialog.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Dialog {
    //#region Inputs
    public readonly dialogTitle = input.required<string>();
    public readonly confirmButton = input<DialogConfirmButtonInput>('Confirm');
    public readonly cancelButton = input<DialogCancelButtonInput>('Cancel');
    public readonly hideDialogActions = input(false);
    public readonly confirmDisabled = input(false);
    public readonly dialogContentClass = input('');
    public readonly isProcessing = input(false);
    public readonly processingAppearance = input<ProcessingAppearance>('body');
    //#endregion

    //#region Outputs
    public readonly dismiss = output<void>();
    public readonly confirm = output<void>();
    //#endregion

    //#region Template methods
    protected onDismiss(): void {
        this.dismiss.emit();
    }

    protected onConfirm(): void {
        this.confirm.emit();
    }
    //#endregion
}
